<template>
<!--  <div v-if="loading" class="flex justify-center items-center h-screen">-->
<!--    <p class="text-xl font-semibold">Loading patient data...</p>-->
<!--  </div>-->
<!--  <div v-else>-->
<!--    <p class="text-xl font-semibold">Loading patient data...</p>-->
<!--    <div class="flex">-->
<!--      <div>-->
<!--        <h1> NEw Self Request</h1>-->
<!--      </div>-->
<!--      <div class="flex-grow">-->
<!--        <PatientSearch-->
<!--            :searchPatient="searchPatient"-->
<!--            :minChars="minChars"-->
<!--            :loading="loading"-->
<!--            :patients="patients"-->
<!--        />-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<div>
  <p>Perrrrrop</p>
</div>
</template>

<script>
import apiClient from "@/services/api";
// import PatientSearch from "@/components/shared/PatientSearch.vue";

export default {
  name: "SelfRequest",
  components: {
    // PatientSearch,
  },
  data() {
    return {
      patients: [],
      loading: false,
      error: null,
      testRequest: {
        labRequestForm: {
          test_type: "",
          priority: "Normal",
          instructions: "",
          quantity: 1,
          bill_category: 2,
          clinical_notes: "",
          unit_price: 0,
        },
        radiologyForm: {
          date: this.getTodayDate(),
          scheduleRequest: "",
          imaging_type: "",
          bodyPartRegion: "",
          priority: "Normal",
          quantity: 1,
          bill_category: 3,
          clinical_notes: "",
          unit_price: 0,
        },
      },
      labRequests: [],
      radiologyRequests: [],
      LabTests: [],
      radiologyTests: [],
      procedures: [],
      isLoading: false,
      searchTimeout: null,
      minChars: 3,
    };
  },
  methods: {
    async searchPatient(searchTerm) {
      try {
        this.loading = true;
        const payload = {
          searchTerm: searchTerm,
        };
        const response = await apiClient.searchPatient(payload);

        if (response.success) {
          this.patients = response.data;
        } else {
          this.loading = false;
          this.$toast.error("Unable to fetch patient information.");
        }
        this.loading = false;
      } catch (error) {
        console.log("error", error);
        this.$toast.error(
          "Unable to fetch patient, please check your internet connection."
        );
      }
    },
    async saveChanges() {
      // Here you would typically send the updated data to your backend
      this.submitting = true;
      try {
        const response = await apiClient.updatePatient(
          this.patientId,
          this.patientData
        );
        if (response.success) {
          this.$toast.success("Patient updated successfully");
          this.fetchPatientData();
        } else {
          this.$toast.error("Failed to update patient information.");
        }
        this.submitting = false;
        this.isEditing = false;
      } catch (error) {
        this.submitting = false;
        this.isEditing = false;
        this.$toast.error("Failed to register patient");
      }
    },
  },
  mounted() {
    // this.fetchPatientData();

    console.log('mounted');
  },
};
</script>
